import { HOURS_IN_DAY, OVERNIGHT_HOUR_MAP } from '../DayView/constants';

// This function does (2) things:
// - Sets the correct wage for the job
//    wageRate seems to come to FE different not as expected from BE for overlapping hours
//    reported here: https://joinhomebase.atlassian.net/browse/SB-3586
// - Uncouples shifts that have overlap in a "Morning Hour",
//    setting it for the same day and/or next day
export function checkForOvernightOverlaps(overnightHourTotals, wageRate) {
  Object.entries(overnightHourTotals).forEach(([hour, hourTotal]) => {
    if (hourTotal?.wages > (wageRate || 0)) {
      // sets correct wage
      const hourTotalObject = {
        ...overnightHourTotals[hour],
        ...{ wages: wageRate },
      };

      // uncouples overlapping "Morning Hour" shifts
      overnightHourTotals[hour] = hourTotalObject;
      overnightHourTotals[hour - HOURS_IN_DAY] = hourTotalObject;
    }
  });

  return overnightHourTotals;
}

export function updateOvernightTotals({
  overnightTimeRange,
  overnightTotals,
  totals,
  wageRate,
}) {
  const copyOfTotals = { ...totals };

  overnightTimeRange.forEach(hour => {
    const hourInOvernightRangeIsAccountedFor = Object.keys(
      copyOfTotals
    ).includes(hour.toString());

    if (hourInOvernightRangeIsAccountedFor) {
      overnightTotals[hour] = copyOfTotals[hour];
    } else {
      overnightTotals[hour] = copyOfTotals[OVERNIGHT_HOUR_MAP[hour]];
      delete copyOfTotals[OVERNIGHT_HOUR_MAP[hour]];
    }
  });

  return checkForOvernightOverlaps(
    { ...overnightTotals, ...copyOfTotals },
    wageRate
  );
}
